// Module
var code = "<p>נשמח לענות :) תוכלו לשאול אותנו על ידי השארת הודעה בעמוד &quot;צור קשר&quot;, שתמצאו בתחתית האתר. אנחנו כבר נחזור אליכם עם התשובה.</p> ";
// Exports
export default code;